import { useMemo } from 'react';

/**
 * Custom hook for managing customer photos filter actions
 * @param {Object} filterState - Current filter state
 * @param {Object} filterActions - Filter action functions
 * @returns {Object} Customer photos filter action functions
 */
const useCustomerPhotosFilterActions = (filterState, filterActions) => {
  // Extract primitives to avoid re-renders when object references change
  const { materialFilter, roomFilter } = filterState;
  const { setMaterialFilter, setRoomFilter, toggleColorFilter } = filterActions;

  const customerPhotosFilterActions = useMemo(
    () => ({
      setMaterialFilter: value => {
        const newValue = materialFilter === value ? '' : value;
        setMaterialFilter(newValue);
      },
      setRoomFilter: value => {
        const newValue = roomFilter === value ? '' : value;
        setRoomFilter(newValue);
      },
      toggleColorFilter: color => {
        toggleColorFilter(color);
      },
    }),
    [
      materialFilter,
      roomFilter,
      setMaterialFilter,
      setRoomFilter,
      toggleColorFilter,
    ]
  );

  return customerPhotosFilterActions;
};

export default useCustomerPhotosFilterActions;
